import { forwardRef } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { Box, Button } from '@mui/material';
import allActions from '../../actions/product_builder';
import isArtworkDefault from '../../utils/isArtworkDefault';
import layout from '../../styles/layout.module.css';
import buttons from '../../styles/buttons.module.css';
import { createCompositeKey } from '../../utils/createCompositeKey';
const modelLiStyle = {
    margin: 'auto'
};
const ModelBox = ({ model, shopifyModel, setOpenNav, currentModel, index }) => {
    const artwork = useSelector((state) => state.rootReducer.currentArtwork);
    let setArtwork = () => {
        if (isArtworkDefault(artwork.leftArtwork.displayName)) {
            const key = createCompositeKey(artwork.leftArtwork.displayName);

            dispatch(allActions.artworkActions.setLeftArtwork(model.artwork[key]));
        }
        if (isArtworkDefault(artwork.rightArtwork.displayName)) {
            const key = createCompositeKey(artwork.rightArtwork.displayName);
            dispatch(allActions.artworkActions.setRightArtwork(model.artwork[key]));
        }
    };
    const updateCurrentModel = () => {
        batch(() => {
            dispatch(allActions.modelActions.updateCurrentModel(model));
            dispatch(allActions.priceActions.updateBasePrice(shopifyModel));
            dispatch(allActions.modelActions.setCurrentPOS(index));
        });

        setArtwork();

        setOpenNav(false);
    };

    const dispatch = useDispatch();
    return (
        <Box style={modelLiStyle}>
            <Button
                className={currentModel === model ? buttons.btnModelActive : ''}
                variant="h4"
                pb={5}
                onMouseEnter={(e) => {
                    e.target.textContent = `${shopifyModel.currency}${parseFloat(
                        shopifyModel.price
                    ).toFixed(2)}`;
                }}
                onMouseLeave={(e) => {
                    e.target.textContent = `${model.name}`;
                }}
                onClick={() => {
                    updateCurrentModel();
                }}>
                {model.name}
            </Button>
        </Box>
    );
};

const ModelNavigation = (props, ref) => {
    const modelList = useSelector((state) => state.rootReducer.modelList.modelList);
    const shopifyCIEMList = useSelector((state) => state.shopifyReducer.ciems);
    const currentModel = useSelector((state) => state.rootReducer.currentModel.currentModel);

    const setNav = (value) => {
        props.setOpenNav(value);
        const navigationBar = document.getElementsByClassName('site-header  logo--left');
        if (navigationBar.length > 0) {
            navigationBar[0].style.zIndex = 1001;
        }
    };

    let modelLi = shopifyCIEMList.map((model, index) => {
        const currModel = modelList.filter((currModel) => currModel.name === model.title)[0];
        return (
            <ModelBox
                model={currModel}
                shopifyModel={model}
                setOpenNav={setNav}
                currentModel={currentModel}
                key={model.title}
                index={index}
            />
        );
    });

    return (
        <Box
            ref={ref}
            className={layout.modelNav}
            style={{ gridTemplateColumns: 'repeat(' + shopifyCIEMList.length + ',1fr)' }}>
            {modelLi}
        </Box>
    );
};
export default forwardRef(ModelNavigation);
